import { FAQsItem } from '@mygpt/app/faqs';
import { Http } from '@mygpt/app/http';

interface FAQChildNoeParams {
  datasetId: string;
  hierarchy_parent_id: string;
  num_levels: number;
  language: string;
}

export interface FAQTreeItem extends FAQsItem {
  hierarchy_parent_id: string;
  child_nodes: FAQTreeItem[];
}

export interface ImportProgressResponse {
  status: 'importing';
  message: string;
  import_progress: {
    batch_id: string;
    language: string;
    language_name: string;
    status: 'in_progress';
    total_faqs: number;
    processed_faqs: number;
    success_faqs: number;
    failed_faqs: number;
    started_at: string;
  };
}
export interface FAQSortItem {
  id: string;
  sort_order: number;
}

export interface UpdateFAQsSortOrderParams {
  datasetId: string;
  items: FAQSortItem[];
}

/**
 * 查树节点数据
 * @param params
 * @returns
 */
export const faqsChildNoe = (params: FAQChildNoeParams) => {
  const { datasetId, ...rest } = params;
  const { get } = Http.use();
  return get<FAQTreeItem[] | ImportProgressResponse>(`/datasets/${datasetId}/faqs/child_node`, {
    params: rest,
  });
};

export interface SearchNodeInfoByIdsParams {
  ai_id: string;
  ids: string[];
  language?: string;
}

export interface FaqNodeSearchByIds {
  id: string;
  question: string;
  language: string;
  dataset_id: string;
  lang_pack_id: string;
}

/**
 * 根据树节点ID查询节点信息
 * @param params
 * @returns
 */
export const searchNodeInfoByIds = (params: SearchNodeInfoByIdsParams) => {
  const { ai_id, ids, language } = params;
  const { post } = Http.use();
  return post<FaqNodeSearchByIds[]>(`/questions/${ai_id}/faqs/list`, ids, {
    params: language ? { language } : undefined,
  });
};

/**
 * 更新问答树排序
 * @param params
 * @returns
 */
export const updateFAQsSortOrder = (params: UpdateFAQsSortOrderParams) => {
  const { datasetId, items } = params;
  const { patch } = Http.use();
  return patch(`/datasets/${datasetId}/faqs/sort_order`, items);
};

export interface ExportFAQTreeParams {
  datasetId: string;
  language?: string;
}

/**
 * 导出FAQ树为JSON文件
 * @param params
 * @returns 文件下载URL
 */
export const exportFAQTree = (params: ExportFAQTreeParams) => {
  const { datasetId, language } = params;
  const { get } = Http.use();
  const queryParams = language ? `?language=${language}` : '';
  return get<Blob>(`/datasets/${datasetId}/faqs/tree_export${queryParams}`, {
    responseType: 'blob',
  });
};
